export const TEST_IDS = {
  HERO_SKELETON: 'hero-skeleton',
  MENU_BUTTON_DESKTOP: 'menu-button-desktop',
};
